export class GlobalState {
  organizationInvitation?: any;
  vaultTimeout?: number;
  vaultTimeoutAction?: string;
  enableBrowserIntegration?: boolean;
  enableBrowserIntegrationFingerprint?: boolean;
}
